/*
 * qi-facets.js -- category-aware filter logic, shared by
 *   assets/qi-search.js               (search results page)
 *   assets/qi-collection-filters.js   (tag collection filter bar)
 *
 * WHY
 *   One fixed set of filters fits nothing. "oz" is a cup's capacity on a mug,
 *   the fabric weight on a tee ("6.1 oz") and the canvas weight on a tote
 *   ("8 oz"); "$8 and up" is a niche on drinkware and 80% of apparel. So each
 *   product is first classified, and each category gets its own attributes.
 *   Price and minimum-order ranges are cut from the products actually shown.
 *
 * WHERE EVERY VALUE COMES FROM (nothing is guessed beyond the product's words)
 *   kind       productType (Drinkware / Apparel / Bags & Backpacks / Pens &
 *              Writing); if blank, keywords in the title and tags
 *   attributes keywords in the title and tags, per category; oz from the title
 *   A product that says nothing about an attribute never matches it.
 */
(function () {
  'use strict';

  var ICONS = {
    mug: '<path d="M4 7h11v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M15 9h2a3 3 0 0 1 0 6h-2"/><path d="M8 2.5c-.6.8-.6 1.7 0 2.5M11 2.5c-.6.8-.6 1.7 0 2.5"/>',
    travel: '<path d="M7 7h10l-1.3 13.2a1 1 0 0 1-1 .8H9.3a1 1 0 0 1-1-.8z"/><path d="M6 7h12"/><path d="M8 4h8l1 3H7z"/><path d="M12 4V2.5"/>',
    tumbler: '<path d="M6 4h12l-1.7 15.2a2 2 0 0 1-2 1.8H9.7a2 2 0 0 1-2-1.8z"/><path d="M6.7 10h10.6"/>',
    straw: '<path d="M6 8h12l-1.5 12.2a1 1 0 0 1-1 .8h-7a1 1 0 0 1-1-.8z"/><path d="M5.5 8h13"/><path d="m12 8 2.5-6H18"/>',
    beer: '<path d="M5 9h10v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"/><path d="M15 11h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2"/><path d="M5 9a2.4 2.4 0 0 1 2.2-3.2 3 3 0 0 1 5.3-.6A2.4 2.4 0 0 1 15 9"/><path d="M8.5 12v6M11.5 12v6"/>',
    cup: '<path d="M5 5h14l-1.9 14.3a2 2 0 0 1-2 1.7H8.9a2 2 0 0 1-2-1.7z"/><path d="M4 5h16"/><path d="M6.3 10h11.4"/>',
    glass: '<path d="M7 3h10l-.9 7.5a4.1 4.1 0 0 1-8.2 0z"/><path d="M12 14.5V21M8.5 21h7"/><path d="M7.5 7h9"/>',
    jar: '<path d="M7 8h10v11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"/><path d="M8 4h8v4H8z"/><path d="M17 11h1.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H17"/>',
    steel: '<rect x="7" y="3" width="10" height="18" rx="2.5"/><path d="M10 6.5v11"/><path d="M7 8h10"/>',
    plastic: '<path d="M10 2h4v3l2 3v12a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V8l2-3z"/><path d="M8 12h8"/>',
    campfire: '<path d="M4 8h11v7a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M15 10h2a2.5 2.5 0 0 1 0 5h-2"/><path d="M3.3 8h12.4"/><path d="M9.5 3c1 .9 1 1.9 0 3"/>',
    bottle: '<path d="M9 2h6v3.5l1.5 2V20a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V7.5L9 5.5z"/><path d="M7.5 11h9"/>',
    shirt: '<path d="M8 3 3.5 6l2 4 2.5-1.2V21h8V8.8L18.5 10l2-4L16 3a4 4 0 0 1-8 0z"/>',
    cap: '<path d="M4 15a8 8 0 0 1 16 0z"/><path d="M4 15h9.5c3 0 6 .8 7.5 2"/><path d="M12 7V5.5"/>',
    polo: '<path d="M8 3 3.5 6l2 4 2.5-1.2V21h8V8.8L18.5 10l2-4L16 3l-2.2 3h-3.6z"/><path d="M12 6v4"/>',
    hoodie: '<path d="M8.5 5.5a3.5 3.5 0 0 1 7 0L20 8l.5 6-2.5.5V21H6v-6.5L3.5 14 4 8z"/><path d="M9.5 6.5 12 10l2.5-3.5"/><path d="M9 16h6"/>',
    jacket: '<path d="M8 3 3.5 6.5 4 21h16l.5-14.5L16 3l-4 3z"/><path d="M12 6v15"/><path d="M8.5 13h1.5M14 13h1.5"/>',
    person: '<circle cx="12" cy="6.5" r="3"/><path d="M5.5 21a6.5 6.5 0 0 1 13 0"/>',
    feather: '<path d="M20 4c-8 0-14 6-14 14v2"/><path d="M20 4c0 7.5-5 13-12 13"/><path d="M6 16h7"/>',
    fabric: '<path d="M4 5h16v14H4z"/><path d="M4 9h16M4 13h16M8 5v14M12 5v14M16 5v14"/>',
    bag: '<path d="M5 8h14l-1 12.1a1 1 0 0 1-1 .9H7a1 1 0 0 1-1-.9z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    tote: '<path d="M4 9h16l-1.4 11.2a1 1 0 0 1-1 .8H6.4a1 1 0 0 1-1-.8z"/><path d="M8.5 9V6.5a3.5 3.5 0 0 1 7 0V9"/>',
    backpack: '<path d="M6 9a6 6 0 0 1 12 0v10.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19.5z"/><path d="M9.5 3.5h5"/><path d="M8.5 14h7v4h-7z"/>',
    drawstring: '<path d="M6 7h12l-1.5 14H7.5z"/><path d="M6 7 12 3l6 4"/><path d="M8 7l-2.5 14M16 7l2.5 14"/>',
    duffel: '<rect x="3" y="9" width="18" height="10" rx="4"/><path d="M8 9V7.5a1.5 1.5 0 0 1 1.5-1.5h5A1.5 1.5 0 0 1 16 7.5V9"/><path d="M3 13h18"/>',
    cooler: '<rect x="4" y="8" width="16" height="12" rx="2"/><path d="M4 12h16"/><path d="M9 8V5h6v3"/><path d="M12 15.5v1"/>',
    laptop: '<rect x="4" y="5" width="16" height="10" rx="1.5"/><path d="M2 19h20"/>',
    leaf: '<path d="M5 19C5 10.5 11 5 20 4c0 9-5.5 15-15 15z"/><path d="M5 19 13 11"/>',
    recycle: '<path d="M7 19H4.5l3-5.2"/><path d="m9.7 8.2 2.3-4 2.4 4.1"/><path d="M17 19h2.5l-3-5.2"/><path d="M7 19h10"/><path d="m6 11 1.5 2.8L10.3 12"/><path d="m16.5 9.5-2.1 1.1 2.4 1.6"/>',
    pen: '<path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z"/><path d="m14.5 5.5 3 3"/>',
    gel: '<path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z"/><path d="M4 21c1.5-.3 2.3-1.2 2.5-2.5"/>',
    stylus: '<rect x="6" y="3" width="12" height="18" rx="2"/><path d="m19.5 4.5-6 6"/><path d="M11 18h2"/>',
    highlighter: '<path d="m9 11 6-6 4 4-6 6z"/><path d="m9 11-4 7h4l2-3"/><path d="M4 21h8"/>',
    pencil: '<path d="M16 3 21 8 9 20H4v-5z"/><path d="M4 15l5 5"/>',
    marker: '<path d="M14 3 21 10l-9 9-7-7z"/><path d="M5 12 3 21l9-2"/>',
    click: '<rect x="9" y="7" width="6" height="14" rx="3"/><path d="M12 7V3"/><path d="M9 3h6"/>',
    twist: '<rect x="9" y="3" width="6" height="18" rx="3"/><path d="M5.5 9a8 8 0 0 0 0 6"/><path d="m4 13.5 1.5 1.5L7 13.5"/>',
    metal: '<path d="M4 18 12 4l8 14z"/><path d="M9 13h6"/>',
    grid: '<rect x="4" y="4" width="7" height="7" rx="1.6"/><rect x="13" y="4" width="7" height="7" rx="1.6"/><rect x="4" y="13" width="7" height="7" rx="1.6"/><rect x="13" y="13" width="7" height="7" rx="1.6"/>',
    layers: '<path d="m12 3 9 5-9 5-9-5z"/><path d="m3 13 9 5 9-5"/>',
    cupsize: '<path d="M3.5 11h5l-.7 9H4.2zM11 5h9.5l-1.3 15h-6.9z"/>',
    award: '<circle cx="12" cy="9" r="5.5"/><path d="m8.6 13.3-1.6 7.7 5-3 5 3-1.6-7.7"/>',
    palette: '<path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.8-.9 1.8-1.9 0-.5-.2-.9-.5-1.3-.3-.3-.5-.8-.5-1.3 0-1 .8-1.8 1.8-1.8h2.1A4.3 4.3 0 0 0 21 10.4C21 6.3 17 3 12 3z"/><circle cx="7.5" cy="11" r="1.2"/><circle cx="10.5" cy="7" r="1.2"/><circle cx="15" cy="7.5" r="1.2"/>'
  };

  /* --------------------------------------------------------------- kinds */
  var KINDS = {
    drink:   { label: 'Drinkware',     icon: 'mug' },
    apparel: { label: 'Apparel',       icon: 'shirt' },
    bag:     { label: 'Bags',          icon: 'tote' },
    pen:     { label: 'Pens & writing', icon: 'pen' },
    other:   { label: 'Other items',   icon: 'grid' }
  };
  function kindOf(title, type, tags) {
    var t = (type || '').toLowerCase();
    if (/drinkware|mugs?|tumblers?|bottles?/.test(t)) return 'drink';
    if (/apparel|clothing|headwear|shirts?/.test(t)) return 'apparel';
    if (/bags?|backpacks?/.test(t)) return 'bag';
    if (/pens?|writing/.test(t)) return 'pen';
    // productType is blank on some products: fall back to their own words
    var x = (title + ' ' + tags.join(' ')).toLowerCase();
    if (/\b(mugs?|tumblers?|cups?|water bottles?|bottles?|steins?|tankards?|glassware|mason jars?|jars?|flasks?|koozies?|can coolers?|drinkware)\b/.test(x)) return 'drink';
    if (/\b(pens?|pencils?|highlighters?|markers?|stylus)\b/.test(x) && !/\b(bags?|totes?|backpacks?)\b/.test(x)) return 'pen';
    if (/\b(totes?|backpacks?|bags?|duffels?|drawstring|sports? packs?|cinch)\b/.test(x)) return 'bag';
    if (/\b(t-?shirts?|tees?|tee's|polos?|hoodies?|hooded|sweatshirts?|jackets?|fleece|caps?|hats?|beanies?|visors?|aprons?|vests?|apparel)\b/.test(x)) return 'apparel';
    return 'other';
  }

  function ozOf(title) {
    var m = title.match(/(\d+(?:\.\d+)?)\s*(?:fl\.?\s*)?oz\b/i);
    return m ? parseFloat(m[1]) : null;
  }
  function has(re) { return function (d) { return re.test(d.x); }; }

  /* ------------------------------------------------------ per-category groups
     Each option's test() receives the derived record d:
       d.x   lower-case title + tags     d.title   raw title     d.oz   number|null */
  var GROUPS = [
    // DRINKWARE ------------------------------------------------------------
    { g: 'cap', kind: 'drink', title: 'Capacity', icon: 'cupsize', grow: true, opts: [
      { v: 's',  label: 'Up to 11 oz',   icon: 'mug', test: function (d) { return d.oz !== null && d.oz <= 11.5; } },
      { v: 'm',  label: '12 – 15 oz', icon: 'mug', test: function (d) { return d.oz !== null && d.oz > 11.5 && d.oz <= 15.5; } },
      { v: 'l',  label: '16 – 20 oz', icon: 'mug', test: function (d) { return d.oz !== null && d.oz > 15.5 && d.oz <= 20.5; } },
      { v: 'xl', label: '21 oz and up',  icon: 'mug', test: function (d) { return d.oz !== null && d.oz > 20.5; } }
    ] },
    { g: 'mat', kind: 'drink', title: 'Material', icon: 'layers', thumb: true, opts: [
      { v: 'ceramic', label: 'Ceramic',          icon: 'mug',      test: has(/ceramic|stoneware|porcelain|ironstone/) },
      { v: 'steel',   label: 'Stainless steel',  icon: 'steel',    test: has(/stainless|\bsteel\b/) },
      { v: 'glass',   label: 'Glass',            icon: 'glass',    test: has(/\bglass\b|mason jar/) },
      { v: 'plastic', label: 'Plastic & Tritan', icon: 'plastic',  test: function (d) { return /plastic|acrylic|tritan|polypropylene|bpa[\s-]?free/.test(d.x) || /\b(PP|AS)\b/.test(d.title); } },
      { v: 'enamel',  label: 'Enamel',           icon: 'campfire', test: has(/enamel|campfire/) }
    ] },
    // APPAREL --------------------------------------------------------------
    { g: 'garment', kind: 'apparel', title: 'Garment Type', icon: 'shirt', thumb: true, opts: [
      { v: 'head',   label: 'Caps & headwear',       icon: 'cap',    test: has(/\b(caps?|hats?|beanies?|visors?|bucket hat|headwear|knit cap)\b/) },
      { v: 'tee',    label: 'T-shirts',              icon: 'shirt',  test: has(/\bt-?shirts?\b|\btees?\b|tee's|beefy-t/) },
      { v: 'polo',   label: 'Polos',                 icon: 'polo',   test: has(/\bpolos?\b|sport shirt/) },
      { v: 'sweat',  label: 'Hoodies & sweatshirts', icon: 'hoodie', test: has(/hood(ie|ed)?s?\b|sweat\s?shirts?|crewneck|pullover/) },
      { v: 'jacket', label: 'Jackets & vests',       icon: 'jacket', test: has(/jackets?|soft ?shell|windbreaker|\bvests?\b|parka|anorak/) }
    ] },
    { g: 'fit', kind: 'apparel', title: 'Fit', icon: 'person', opts: [
      { v: 'youth',  label: 'Youth & kids', icon: 'person', test: has(/\b(youth|kids?|toddler|infant|children)\b/) },
      { v: 'ladies', label: 'Ladies’', icon: 'person', test: has(/\b(ladies|women'?s?|womens)\b/) }
    ] },
    { g: 'fabric', kind: 'apparel', title: 'Fabric', icon: 'fabric', opts: [
      // blends first: "Cotton/Poly" must not read as 100% cotton
      { v: 'blend',   label: 'Cotton / poly blend',     icon: 'fabric',  test: has(/cotton\s*\/\s*poly|50\s*\/\s*50|dryblend|dry blend|core blend|heavy blend|tri-?blend|\bblend\b/) },
      { v: 'cotton',  label: '100% cotton',             icon: 'shirt',   test: function (d) { return /100% cotton|ultra cotton|heavy cotton|beefy-t|cotton twill|brushed cotton|ring-?spun|\bcotton\b/.test(d.x) && !/cotton\s*\/\s*poly|50\s*\/\s*50|blend/.test(d.x); } },
      { v: 'perf',    label: 'Polyester & performance', icon: 'feather', test: has(/polyester|performance|moisture|wicking|dri-?fit|posicharge|competitor|sport-tek|athletic/) },
      { v: 'fleece',  label: 'Fleece',                  icon: 'hoodie',  test: has(/fleece/) },
      { v: 'knit',    label: 'Knit & acrylic',          icon: 'cap',     test: has(/\bknit\b|acrylic/) }
    ] },
    { g: 'weight', kind: 'apparel', title: 'Fabric Weight', icon: 'feather', opts: [
      { v: 'light', label: 'Lightweight (under 5 oz)', icon: 'feather', test: function (d) { return d.oz !== null && d.oz < 5; } },
      { v: 'mid',   label: 'Midweight (5 – 7 oz)', icon: 'shirt',   test: function (d) { return d.oz !== null && d.oz >= 5 && d.oz < 7; } },
      { v: 'heavy', label: 'Heavyweight (7 oz +)',     icon: 'hoodie',  test: function (d) { return d.oz !== null && d.oz >= 7; } }
    ] },
    // BAGS -----------------------------------------------------------------
    { g: 'bagtype', kind: 'bag', title: 'Bag Type', icon: 'bag', thumb: true, opts: [
      { v: 'tote',       label: 'Totes & shoppers',   icon: 'tote',       test: has(/\btotes?\b|shopper|grocery/) },
      { v: 'backpack',   label: 'Backpacks',          icon: 'backpack',   test: function (d) { return /backpack/.test(d.x) && !/drawstring|cinch/.test(d.x); } },
      { v: 'drawstring', label: 'Drawstring & cinch', icon: 'drawstring', test: has(/drawstring|cinch|sports? pack/) },
      { v: 'duffel',     label: 'Duffels & gym bags', icon: 'duffel',     test: has(/duffel|gym bag|sport bag|travel bag/) },
      { v: 'cooler',     label: 'Coolers & lunch',    icon: 'cooler',     test: has(/cooler|insulated|lunch/) },
      { v: 'laptop',     label: 'Laptop & business',  icon: 'laptop',     test: has(/laptop|messenger|brief|computer/) }
    ] },
    { g: 'bagmat', kind: 'bag', title: 'Material', icon: 'layers', thumb: true, opts: [
      { v: 'nonwoven', label: 'Non-woven',          icon: 'fabric',  test: has(/non-?woven/) },
      { v: 'cotton',   label: 'Cotton & canvas',    icon: 'tote',    test: has(/cotton|canvas/) },
      { v: 'jute',     label: 'Jute & natural',     icon: 'leaf',    test: has(/jute|burlap|hemp|bamboo/) },
      { v: 'poly',     label: 'Polyester & nylon',  icon: 'feather', test: function (d) { return /polyester|nylon|ripstop/.test(d.x) || /\b\d{2,4}\s?d\b/i.test(d.title); } },
      { v: 'recycled', label: 'Recycled (rPET)',    icon: 'recycle', test: has(/recycled|rpet/) }
    ] },
    // PENS -----------------------------------------------------------------
    { g: 'pentype', kind: 'pen', title: 'Writing', icon: 'pen', thumb: true, opts: [
      { v: 'ball',   label: 'Ballpoint',    icon: 'pen',         test: has(/ball ?point/) },
      { v: 'gel',    label: 'Gel',          icon: 'gel',         test: has(/\bgel\b/) },
      { v: 'stylus', label: 'Stylus pens',  icon: 'stylus',      test: has(/stylus/) },
      { v: 'hi',     label: 'Highlighters', icon: 'highlighter', test: has(/highlight/) },
      { v: 'pencil', label: 'Pencils',      icon: 'pencil',      test: has(/pencils?\b/) },
      { v: 'marker', label: 'Markers',      icon: 'marker',      test: has(/markers?\b/) }
    ] },
    { g: 'action', kind: 'pen', title: 'Mechanism', icon: 'click', opts: [
      { v: 'click', label: 'Click / retractable', icon: 'click', test: has(/click|plunger|retractable|push/) },
      { v: 'twist', label: 'Twist',               icon: 'twist', test: has(/twist/) }
    ] },
    { g: 'barrel', kind: 'pen', title: 'Barrel', icon: 'metal', thumb: true, opts: [
      { v: 'metal',   label: 'Metal',         icon: 'metal',   test: has(/metal|alumin|brass|chrome|stainless|steel/) },
      { v: 'plastic', label: 'Plastic',       icon: 'plastic', test: has(/plastic|translucent|acrylic/) },
      { v: 'wood',    label: 'Wood & bamboo', icon: 'leaf',    test: has(/\bwood|bamboo/) },
      { v: 'recycled', label: 'Recycled',     icon: 'recycle', test: has(/recycled|rpet|eco/) }
    ] }
  ];
  GROUPS.forEach(function (gr) { gr.byV = {}; gr.opts.forEach(function (o) { gr.byV[o.v] = o; }); });

  /* ------------------------------------------------------------------ brands
     The store's own brand list: every tag linked from /pages/brands
     (templates/page.brands.liquid), as tag handles. A brand tag is a Brand
     filter, never a "style". */
  var BRANDS = {};
  '3m a4 adams american-tourister anker arctic-zone ash-city atchison bagedge bella-canvas bettoni bic big-accessories buck burnside callaway camelbak case-logic cedar-creek champion clique coast coleman columbia corkcicle cornerstone cutter-buck devon-jones dickies district dyln-bottles econscious ecovessel eddie-bauer elleven field-co flexfit fruit-of-the-loom gerber gildan hanes harriton herschel hidratespark high-sierra hitch hydrapak-recon icool jaffa jerzees jockey kenneth-cole kershaw koozie leatherman led-lenser liberty-bags maglite mammoth miir modern-sprout moleskine mophie moptoppers mycharge next-level nike nite-ize ogio osprey perka polar-bottles popsockets port-authority port-company post-it pul-smartcap puma realtree red-house red-kap reduce rume scripto sharpie skullcandy slowtide smith-wesson snowfox solo sport-tek swig swiss-army takeya tentree thermos titleist vapur vinglace w-p wilson yeti zippo zoom'.split(' ').forEach(function (h) { BRANDS[h] = 1; });
  function handleize(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function isBrand(tag) { return !!BRANDS[handleize(tag)]; }
  // display name for each brand handle, as the products spell it ("Port & Company")
  var BRAND_NAME = {};


  /* ------------------------------------------------------------------ colour
     From the product's image FILENAMES -- the same source the product page uses
     for its colour names ("Q957265-black-mugs-with-logo.jpg"). Names are often
     run together ("trueredwhite", "blueiceorangeice", "mattesilver"), so words
     are found inside tokens; FALSE strips words that merely contain a colour
     ("colored", "covered", "standard"), WHOLE lists short words that only count
     standing alone. Group shots ("-1-all") and blanks carry no colour and simply
     never match a colour filter. Measured on DEV: 78-100% of products per
     category get at least one colour. */
  var COLORS = [
    ['black',  'Black',  ['black', 'onyx', 'ebony', 'jet'], '#1d1d1f'],
    ['white',  'White',  ['white', 'ivory', 'cream', 'natural', 'snow', 'pearl'], '#ffffff'],
    ['gray',   'Gray',   ['gray', 'grey', 'heather', 'charcoal', 'graphite', 'slate', 'smoke', 'gunmetal'], '#9aa0a6'],
    ['silver', 'Silver', ['silver', 'chrome', 'stainless'], 'linear-gradient(135deg,#f3f4f6,#a7acb4)'],
    ['red',    'Red',    ['red', 'maroon', 'burgundy', 'crimson', 'cardinal', 'cherry', 'scarlet'], '#d62828'],
    ['pink',   'Pink',   ['pink', 'magenta', 'fuchsia', 'coral', 'salmon', 'raspberry'], '#f06ba8'],
    ['orange', 'Orange', ['orange', 'tangerine', 'rust', 'pumpkin'], '#f77f00'],
    ['yellow', 'Yellow', ['yellow', 'lemon', 'mustard', 'daisy', 'banana'], '#fcd34d'],
    ['gold',   'Gold',   ['gold', 'bronze', 'brass', 'copper'], 'linear-gradient(135deg,#f8e08e,#b8860b)'],
    ['green',  'Green',  ['green', 'lime', 'kelly', 'forest', 'olive', 'mint', 'teal', 'emerald', 'hunter', 'sage', 'army', 'asparagus', 'jade'], '#2e9b4f'],
    ['blue',   'Blue',   ['blue', 'royal', 'navy', 'sky', 'aqua', 'cyan', 'turquoise', 'cobalt', 'denim', 'sapphire', 'carolina', 'columbia'], '#2563eb'],
    ['purple', 'Purple', ['purple', 'violet', 'lavender', 'plum', 'lilac', 'grape', 'orchid'], '#7c3aed'],
    ['brown',  'Brown',  ['brown', 'tan', 'khaki', 'chocolate', 'beige', 'espresso', 'camel', 'mocha', 'kraft', 'sand'], '#8b5e3c'],
    ['clear',  'Clear',  ['clear', 'translucent', 'frosted', 'frost', 'transparent'], 'repeating-conic-gradient(#e5e7eb 0 25%,#fff 0 50%) 0 0/8px 8px'],
    ['camo',   'Camo',   ['camo', 'camouflage', 'realtree', 'mossyoak'], 'radial-gradient(circle at 30% 30%,#5b6b3a 0 22%,transparent 23%),radial-gradient(circle at 70% 60%,#3b3a2a 0 20%,transparent 21%),radial-gradient(circle at 35% 75%,#8a7a52 0 18%,transparent 19%),#6f7d4a']
  ];
  var COLOR_FALSE = /colou?red|multicolou?r|shred|embroider|hundred|tired|fired|starred|[a-z]*(?:e|u)red(?=\b|[^a-z])|stand|tank|tangle|instant|sandal|thousand|redwood|rustic|trust|orchard|skyline|bluetooth|whiteboard|greenhouse|grayscale|silverware|blackboard|goldfish/g;
  var COLOR_WHOLE = { tan: 1, jet: 1, sky: 1, sand: 1, rust: 1, mint: 1, sage: 1, army: 1, jade: 1, plum: 1, snow: 1 };
  var SWATCH = {};
  COLORS.forEach(function (c) { SWATCH[c[0]] = c[3]; });
  // imgs: filenames joined by "|"
  function colorsOf(imgs) {
    var out = [];
    String(imgs || '').split('|').forEach(function (fn) {
      if (!fn) return;
      var s = fn.toLowerCase()
        .replace(/\.(jpe?g|png|webp|gif)$/, '')
        .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/, '')
        .replace(/\bq\d{3,7}\b/g, ' ')
        .replace(/with-?logo|wiht-logo/g, ' ')
        .replace(/truered/g, 'true red')
        .replace(/wine|coffee|rose(?!gold)|wood|bamboo/g, ' ')   // product words, not colours
        .replace(/[^a-z]+/g, ' ')
        .replace(COLOR_FALSE, ' ');
      var toks = s.split(' ').filter(Boolean);
      COLORS.forEach(function (c) {
        if (out.indexOf(c[0]) > -1) return;
        for (var i = 0; i < c[2].length; i++) {
          var w = c[2][i];
          var hit = COLOR_WHOLE[w] ? toks.indexOf(w) > -1 : toks.some(function (t) { return t.indexOf(w) > -1; });
          if (hit) { out.push(c[0]); return; }
        }
      });
    });
    return out;
  }

  /* Card image follows the Color filter: show each card in the colour picked
     LAST (wanted[0]), falling back to earlier picks for products that do not
     come in it. Among a product's images in that colour, a single-colour shot
     beats a group shot. URLs come from the card's own thumbnail strip, which
     lists the product's images in the same order as the filenames. With nothing
     wanted, the card's original image comes back. Same swap as the theme's
     swatch hover (assets/site-upgrade-2026.js), so hovering still works. */
  var IMG_CACHE = {};   // handle -> Promise of the product's image URLs
  function productImages(handle) {
    if (!IMG_CACHE[handle]) {
      IMG_CACHE[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { images: [] }; })
        .then(function (p) { return p.images || []; })
        .catch(function () { return []; });
    }
    return IMG_CACHE[handle];
  }
  function setImg(img, url) {
    if (!url || img.getAttribute('src') === url) return;
    img.setAttribute('src', url);
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', url);
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }
  function showColor(card, imgs, wanted) {
    var img = card.querySelector('.product-grid-image--centered img') || card.querySelector('.product-grid-item img');
    if (!img) return;
    if (!img.hasAttribute('data-qi-orig')) img.setAttribute('data-qi-orig', img.getAttribute('src') || img.getAttribute('data-src') || '');
    var key = (wanted || []).join(',');
    card.setAttribute('data-qi-want', key);
    var best = -1;
    if (wanted && wanted.length) {
      var names = String(imgs || '').split('|').filter(Boolean);
      for (var w = 0; w < wanted.length && best < 0; w++) {
        var bestN = 99;
        for (var i = 0; i < names.length; i++) {
          var c = colorsOf(names[i]);
          if (c.indexOf(wanted[w]) > -1 && c.length < bestN) { best = i; bestN = c.length; }
        }
      }
    }
    if (best < 0) { setImg(img, img.getAttribute('data-qi-orig')); return; }
    var thumbs = card.querySelectorAll('.product-photo-super-thumb[data-image]');
    if (best < thumbs.length) { setImg(img, thumbs[best].getAttribute('data-image')); return; }
    // past the 8-swatch strip: ask Shopify for the product's image list (cached)
    var handle = card.getAttribute('data-handle');
    if (!handle) { setImg(img, img.getAttribute('data-qi-orig')); return; }
    productImages(handle).then(function (list) {
      if (card.getAttribute('data-qi-want') !== key) return;     // the shopper has moved on
      var u = list[best];
      if (!u) return;
      setImg(img, u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=480');
    });
  }
  /* ?color=yellow  ?color=yellow,red  ?color=yellow&color=red
     Case-insensitive; shade words map to their family through the same matcher
     the filenames use (navy -> blue, maroon -> red); unknown words are dropped.
     Returned in the order given, so the LAST one leads the card images, exactly
     as if it had been picked last. */
  function colorsFromUrl(search) {
    var out = [], re = /[?&]color=([^&]*)/g, m;
    while ((m = re.exec(search || ''))) {
      var raw;
      try { raw = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { raw = m[1]; }
      raw.split(/[\s,|]+/).forEach(function (w) {
        w = w.toLowerCase();
        if (!w) return;
        (SWATCH[w] ? [w] : colorsOf(w)).forEach(function (v) {
          var i = out.indexOf(v);
          if (i > -1) out.splice(i, 1);
          out.push(v);
        });
      });
    }
    return out;
  }

  /* "red hats" -> { colors: ['red'], rest: 'hats' }. Shopify's search treats a
     colour word loosely -- it mostly drags in unrelated items that mention it
     ("black backpacks" 262 vs "backpacks" 257, "red bandanas" 10 vs 2) -- while
     the product's real colours live in its image filenames. So a colour+product
     search runs as the product search with the Color filter applied.
     Whole words only, from a curated list (no "sky", "natural", "rose" ...).
     Left alone: a lone colour ("black"), brand names ("Red House"), and phrases
     where the colour is part of the product ("whiteboard", "black light"). */
  var QUERY_COLORS = ['black', 'white', 'gray', 'grey', 'silver', 'red', 'pink', 'orange', 'yellow', 'gold',
    'green', 'blue', 'purple', 'brown', 'clear', 'camo', 'camouflage', 'navy', 'royal', 'maroon', 'burgundy',
    'teal', 'lime', 'charcoal', 'heather', 'khaki', 'beige', 'ivory', 'cream', 'turquoise', 'aqua', 'lavender',
    'tan', 'violet', 'magenta', 'fuchsia', 'olive', 'coral', 'translucent', 'transparent'];
  // colour words trusted in a product title (narrower than the query list)
  var TITLE_COLORS = ['black', 'white', 'gray', 'grey', 'silver', 'red', 'pink', 'orange', 'yellow', 'gold',
    'green', 'blue', 'purple', 'brown', 'clear', 'translucent', 'camo', 'camouflage', 'navy', 'maroon', 'burgundy', 'charcoal'];
  var QUERY_KEEP = /\b(white ?boards?|black ?boards?|black ?lights?|green ?tea|red ?cross|silver ?ware|gold ?fish|blue ?tooth|orange ?juice|red ?wine|white ?wine|clear ?coat)\b/;
  var COLOR_MODS = /^(light|dark|bright|neon|hot|deep|true|royal|pale|matte|metallic)$/;
  function splitColorQuery(q) {
    var s = String(q || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!s || QUERY_KEEP.test(s) || isBrand(s)) return null;
    var cols = [], rest = [];
    s.split(' ').forEach(function (t) { (QUERY_COLORS.indexOf(t) > -1 ? cols : rest).push(t); });
    if (!cols.length) return null;
    rest = rest.filter(function (t) { return !COLOR_MODS.test(t); });   // "light blue" -> blue
    if (!rest.length) return null;
    return { colors: cols, rest: rest.join(' ') };
  }

  // keep "last picked" order: wanted = picks newest-first
  function pickOrder(order, on) {
    order = order.filter(function (v) { return on[v]; });
    for (var k in on) if (on[k] && order.indexOf(k) === -1) order.push(k);
    return order;
  }

  /* ------------------------------------------------------------- derivation */
  // p: {title, type, tags[]} -> { kind, attr: { g: [values] } }
  function derive(p) {
    var tags = p.tags || [];
    var d = { title: p.title || '', x: ((p.title || '') + ' ' + tags.join(' ')).toLowerCase(), oz: ozOf(p.title || '') };
    var kind = kindOf(d.title, p.type, tags), attr = {};
    GROUPS.forEach(function (gr) {
      if (gr.kind !== kind) return;
      var vals = gr.opts.filter(function (o) { return o.test(d); }).map(function (o) { return o.v; });
      if (vals.length) attr[gr.g] = vals;
    });
    var br = tags.filter(isBrand);
    if (br.length) {
      attr.brand = br.map(function (t) { var h = handleize(t); if (!BRAND_NAME[h]) BRAND_NAME[h] = t; return h; });
    }
    var cols = colorsOf(p.imgs);
    // camo usually lives in the title or tags, not the filenames
    if (cols.indexOf('camo') === -1 && /\bcamo|camouflage|realtree|mossy ?oak/.test(d.x)) cols.push('camo');
    // a colour named in the TITLE describes the product ("Clear Stadium Backpack",
    // "White Shiny Bistro Mugs") -- whole words only, so "Redwood" is not red
    String(p.title || '').toLowerCase().split(/[^a-z]+/).forEach(function (t) {
      if (TITLE_COLORS.indexOf(t) === -1) return;
      (SWATCH[t] ? [t] : colorsOf(t)).forEach(function (v) { if (cols.indexOf(v) === -1) cols.push(v); });
    });
    if (cols.length) attr.color = cols;
    return { kind: kind, attr: attr, oz: d.oz };
  }

  /* Which groups to offer for a set of derived items:
     - "kind" itself, when two or more categories each have 2+ products
     - a category's groups when it makes up at least half the set, or is the
       category the shopper has picked; only groups with 2+ live options */
  function plan(recs, pickedKinds) {
    var byKind = {}, total = recs.length;
    recs.forEach(function (r) { byKind[r.kind] = (byKind[r.kind] || 0) + 1; });
    var kinds = Object.keys(byKind).filter(function (k) { return byKind[k] >= 2; });
    var out = { kinds: kinds.length >= 2 ? kinds.sort(function (a, b) { return byKind[b] - byKind[a]; }) : [], groups: [] };
    GROUPS.forEach(function (gr) {
      var share = (byKind[gr.kind] || 0) / (total || 1);
      if (share < 0.5 && !(pickedKinds && pickedKinds[gr.kind])) return;
      // offer the group if choosing in it would actually narrow the list
      var inKind = byKind[gr.kind] || 0, live = 0, narrows = false;
      gr.opts.forEach(function (o) {
        var n = recs.filter(function (r) { return r.attr[gr.g] && r.attr[gr.g].indexOf(o.v) > -1; }).length;
        if (n > 0) { live++; if (n < inKind) narrows = true; }
      });
      if (live >= 2 || (live === 1 && narrows)) out.groups.push(gr);
    });
    // Colour: when 2+ colours are present and at least 40% of the set has a
    // known colour -- below that the filter would quietly hide most products
    var cn = {}, withColor = 0;
    recs.forEach(function (r) { if (r.attr.color) { withColor++; r.attr.color.forEach(function (c) { cn[c] = (cn[c] || 0) + 1; }); } });
    var cv = COLORS.filter(function (c) { return cn[c[0]]; }).sort(function (a, b) { return cn[b[0]] - cn[a[0]]; });
    if (cv.length >= 2 && withColor >= 0.4 * total) {
      var cg = { g: 'color', kind: '*', title: 'Color', icon: 'palette', swatch: true, byV: {}, opts: cv.map(function (c) {
        return { v: c[0], label: c[1], icon: 'palette', swatch: c[3] };
      }) };
      cg.opts.forEach(function (o) { cg.byV[o.v] = o; });
      out.groups.push(cg);
    }
    // No Brand filter (removed on request). attr.brand is still derived: the
    // brand list also keeps brand names out of the colour keyword search.
    return out;
  }

  /* ------------------------------------------------ ranges from the data */
  function niceStep(v) { return v < 3 ? 0.5 : v < 10 ? 1 : v < 30 ? 5 : v < 100 ? 10 : 50; }
  function roundNice(v) { var s = niceStep(v); return Math.round(v / s) * s; }
  // 3-4 price bands cut at the quartiles of what is shown, rounded to friendly numbers
  function priceBands(prices) {
    var p = prices.filter(function (v) { return v !== null && isFinite(v); }).sort(function (a, b) { return a - b; });
    if (p.length < 4 || p[p.length - 1] - p[0] < 0.5) return [];
    var cuts = [0.25, 0.5, 0.75].map(function (q) { return roundNice(p[Math.floor(q * (p.length - 1))]); });
    cuts = cuts.filter(function (c, i) { return c > p[0] && c < p[p.length - 1] && cuts.indexOf(c) === i; });
    if (!cuts.length) return [];
    var bands = [], lo = 0;
    cuts.forEach(function (c) { bands.push([lo, c]); lo = c; });
    bands.push([lo, Infinity]);
    return bands.map(function (b, i) {
      var label = i === 0 ? 'Under ' + money(b[1]) : b[1] === Infinity ? money(b[0]) + ' and up' : money(b[0]) + ' – ' + money(b[1]);
      return { v: 'p' + i, label: label, lo: b[0], hi: b[1] };
    });
  }
  function money(v) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  // minimum-order thresholds that actually split this set
  var MIN_STEPS = [12, 24, 25, 36, 48, 50, 72, 100, 144, 150, 250, 300, 500];
  function minSteps(mins) {
    var m = mins.filter(function (v) { return v > 0; });
    if (m.length < 3) return [];
    var out = [], last = 0;
    MIN_STEPS.forEach(function (t) {
      var n = m.filter(function (v) { return v <= t; }).length;
      if (n > last && n < m.length && out.length < 4) { out.push(t); last = n; }
    });
    return out;
  }

  /* The filter panels (search sidebar, collection left panel) stick below the
     theme's sticky header + menu (layout/theme.liquid .sticky-header/.sticky-menu)
     and scroll on their own. Their height varies (yellow banner, wrapping menu),
     so measure it into --qi-stick instead of guessing. */
  function stickTop() {
    var h = 0;
    ['.sticky-header', '.sticky-menu'].forEach(function (s) {
      var el = document.querySelector(s);
      if (el && getComputedStyle(el).position === 'sticky') h += el.offsetHeight;
    });
    document.documentElement.style.setProperty('--qi-stick', (h + 12) + 'px');
    stickH = h + 12;
    fitPanels();
  }
  /* A panel's height is the space it can actually see: from where it starts
     now to the bottom of the screen. Before it sticks (page not scrolled yet,
     panel still below the heading) a plain "screen height" cap would push its
     bottom off-screen, so its last filters could not be reached until the page
     itself was scrolled. Re-fitted on every scroll frame; once stuck under the
     header it gets the full height. */
  var stickH = 150, fitQueued = false;
  function fitPanels() {
    fitQueued = false;
    [].forEach.call(document.querySelectorAll('.qis-filters, .qcf-side'), function (el) {
      if (getComputedStyle(el).position !== 'sticky') { el.style.maxHeight = ''; return; }
      var top = Math.max(el.getBoundingClientRect().top, stickH);
      el.style.maxHeight = Math.max(240, window.innerHeight - top - 12) + 'px';
    });
  }
  function fitSoon() { if (!fitQueued) { fitQueued = true; requestAnimationFrame(fitPanels); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickTop); else stickTop();
  window.addEventListener('load', stickTop);
  window.addEventListener('resize', stickTop);
  window.addEventListener('scroll', fitSoon, { passive: true });

  window.QIFacets = {
    ICONS: ICONS, KINDS: KINDS, GROUPS: GROUPS,
    kindOf: kindOf, derive: derive, plan: plan, isBrand: isBrand, handleize: handleize,
    colorsOf: colorsOf, SWATCH: SWATCH, showColor: showColor, pickOrder: pickOrder, colorsFromUrl: colorsFromUrl, splitColorQuery: splitColorQuery,
    priceBands: priceBands, minSteps: minSteps, fitPanels: fitPanels,
    icon: function (n, cls) { return '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') + '>' + (ICONS[n] || ICONS.grid) + '</svg>'; }
  };
})();
